<div class="bg-image ">
    <ng-container *ngIf="inputData != null">
        <div class="portfolio-agency-banner pa-bg1 jarallax" data-jarallax='{"speed": 0.3}'
            style="height: 120px; display: flex; align-items: center; justify-content: center;">
            <div class="container-fluid">
                <div class="banner-content text-center" style="font-family: 'Li Ador Noirrit SemiBold';">
                    <h1 style="color: white; margin: 0;padding-bottom: -10px !important;padding-top: 15px !important;">
                        {{inputData.TitleEn}}</h1>
                </div>
            </div>
        </div>

        <div class="container-fluid " style="padding-bottom: 20px;">
            <br>
            <br>

            <div class="container" style="text-align: center;">
                <div class="row">
                    <div class="col-md-12">
                        <p>
                            <span
                                style="text-align: justify !important;font-family: 'Li Ador Noirrit SemiBold';font-size: 18px;"
                                [innerHTML]="inputData.DetailsEn">
                            </span>
                        </p>
                    </div>
                </div>
                <div class="container">
                    <div class="container">
                        <div class="gallery-container">
                            <div class="row">

                                <ng-container *ngFor="let item of inputData.ShowAttachments[0]">


                                    <div class="col-lg-4 col-md-4 col-sm-12"
                                        style="margin-bottom: 30px; margin-top:20px">


                                        <div class="single-team-box">

                                            <div class="image" style="height: 200px;">
                                                <img [src]="item.FilePath">
                                            </div>
                                            <div class="content" *ngIf="item.Title != ''">
                                                <h4>{{item.Title}}
                                                </h4>
                                            </div>

                                        </div>

                                    </div>
                                </ng-container>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>